import React, { MutableRefObject, Ref } from 'react'
import { ToggleButton, ToggleButtonGroup } from '@mui/material'
import i18n from 'i18n'

export interface SegmentItem {
  value: any
  title: string
}

export interface SegmentButtonProps {
  items: SegmentItem[]
  selected?: SegmentItem
  onSelect: (segmentItem: SegmentItem) => void
  width?: string
}

const cornerRadius = '8px'

export default function SegmentButton(props: SegmentButtonProps) {
  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newValue: string
  ) => {
    const newItem = props.items.find((item) => item.value === newValue)
    if (newItem) props.onSelect(newItem)
  }

  const isRtl = i18n.dir() === 'rtl'
  const visualIndexFor = (index: number) =>
    isRtl ? props.items.length - 1 - index : index

  const buttonSX = (index: number) => {
    const visualIndex = visualIndexFor(index)

    return {
      flex: 1,

      ...(visualIndex === 0 && {
        borderTopLeftRadius: cornerRadius,
        borderBottomLeftRadius: cornerRadius
      }),
      ...(visualIndex === props.items.length - 1 && {
        borderTopRightRadius: cornerRadius,
        borderBottomRightRadius: cornerRadius
      })
    }
  }

  return (
    <>
      {props.items.length > 0 ? (
        <ToggleButtonGroup
          sx={{
            width: props.width ?? 'auto',
            height: '30px',
            display: 'flex',
            flexDirection: isRtl ? 'row-reverse' : 'row',
            border: '1px solid var(--color-border-default)',
            borderRadius: cornerRadius,
            backgroundColor: 'var(--color-surface-card)'
          }}
          value={props.selected?.value}
          exclusive
          onChange={handleChange}
        >
          {props.items.map((item, index) => {
            return (
              <ToggleButton
                key={item.value}
                sx={{
                  ...buttonSX(index),
                  textTransform: 'none',
                  border: 0,
                  color: 'var(--color-text-secondary)',
                  '&:hover': {
                    backgroundColor: 'var(--color-surface-hover)'
                  },
                  '&.Mui-selected, &.Mui-selected:hover': {
                    backgroundColor: 'var(--app-accent-color)',
                    color: 'var(--app-selected-color, #fff)'
                  }
                }}
                value={item.value}
              >
                {item.title.toLowerCase()}
              </ToggleButton>
            )
          })}
        </ToggleButtonGroup>
      ) : (
        <>No items</>
      )}
    </>
  )
}
